<div class="row">
  <div class="col-12">
    <!-- title -->
    <div class="table-responsive mb-0">
      <div class="row">
        <div class="col-8">
          <magieno-input-text-field [advancedFormControl]="this.title"
          type="string"></magieno-input-text-field>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <magieno-boolean-select
          [advancedFormControl]="this.isRightToVote"></magieno-boolean-select>
        </div>
      </div>
      <magieno-boolean-select
      [advancedFormControl]="this.isRightToParticipate"></magieno-boolean-select>

      @if (this.shareClassForm.value.isRightToParticipate === false) {
        <td>
          <magieno-input-money-field [advancedFormControl]="this.redemptionValue"
            [currency]="this.currency"
          [locale]="this.locale"></magieno-input-money-field>
        </td>
      }

    </div>

    <app-rollover-share-class-share-holder-distributions-form [form]="this.form" [shareClassForm]="shareClassForm"
    [shareClassIndex]="index"></app-rollover-share-class-share-holder-distributions-form>

  </div>
</div> <!-- / .row -->
